import React, { useMemo } from 'react'
import { useLocation, Outlet } from 'react-router-dom'

import { SideMenu } from '@app/components'
import { ErrorBoundary } from '@app/components/util'

import { getMenuItemGroups } from '@app/utils/menu'
import { useExtendedNavigate, useSideMenu, useUserQuery } from '@app/hooks'

import styles from './styles.module.scss'
import { rawMenuItems } from './configs'

import type { Key } from 'react'
import type { MenuItemGroup } from '@app/types/menu'

export const BaseLayout: React.FC = () => {
  const location = useLocation()
  const navigate = useExtendedNavigate()
  const { isCollapse, toggleSideMenu } = useSideMenu()

  const { data: user } = useUserQuery()

  const menuItems: MenuItemGroup[] = useMemo(
    () => getMenuItemGroups({ userRoles: user?.roles, rawMenuItemGroups: rawMenuItems }),
    [user]
  )

  const selectedKey = useMemo(() => {
    const { pathname } = location

    const slashIndex = pathname.slice(1).indexOf('/')
    const end = slashIndex > 0 ? slashIndex + 1 : undefined

    return pathname.slice(0, end)
  }, [location])

  const handleSideMenuClick = (menuKey: Key): void => {
    const isNewMenuItem = menuKey !== location.pathname

    isNewMenuItem && navigate(String(menuKey))
  }

  return (
    <div className={ styles.baseLayout }>
      <SideMenu
        isCollapse={ isCollapse }
        className={ styles.baseLayout__aside }
        selectedKey={ selectedKey }
        items={ menuItems }
        onMenuItemClick={ handleSideMenuClick }
        onCollapseButtonClick={ toggleSideMenu }
      />

      <main className={ styles.baseLayout__main }>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  )
}
